import React, { useEffect } from 'react'
import { addRlog } from 'utils/util'
import SwiperBox from './components/Swiper'
import VolunMessage from './components/VolunMessage'
import CollegeNews from './components/CollegeNews'

const Home: React.FC<{}> = () => {
  useEffect(() => {
    addRlog('page_enter', {
      page_name: '首页'
    })
  }, [])
  return (
    <div>
      <SwiperBox />
      <VolunMessage />
      <CollegeNews />
    </div>
  )
}

export default Home
